import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import { Chip } from '@mui/material';
import { TAG_TYPES } from 'lib/constants';
import { Tag } from 'lib/types/tags';
import { updateRouterQuery } from 'lib/utils/filterUtils';

interface Props {
  allTags?: Tag[];
}

export const TagsCol = ({ allTags }: Props) => {
  const router = useRouter();
  if (!allTags) return null;

  const tags = allTags.filter((tag) => tag.tagTypeId === TAG_TYPES.tag.id);
  const events = allTags.filter((tag) => tag.tagTypeId === TAG_TYPES.event.id);

  const onClick = (query: ParsedUrlQuery) => {
    updateRouterQuery(router, query);
  };

  return (
    <div className="flex flex-col gap-2 max-w-[350px]">
      {tags.length > 0 && (
        <div>
          <span className="font-medium">tags:</span>
          {tags.map((t) => (
            <Chip
              key={t.id}
              size="small"
              onClick={() => onClick({ tags: `${t.tagValue.value}~${t.tagValueId}` })}
              label={t.tagValue.value}
              sx={{ margin: '2px' }}
              className="hover:underline"
            />
          ))}
        </div>
      )}
      {events.length > 0 && (
        <div>
          <span className="font-medium">events:</span>
          {events.map((t) => (
            <Chip
              key={t.id}
              size="small"
              onClick={() => onClick({ events: `${t.tagValue.value}~${t.tagValueId}` })}
              label={t.tagValue.value}
              sx={{ margin: '2px' }}
              className="hover:underline"
            />
          ))}
        </div>
      )}
    </div>
  );
};
